import { DataProxy } from 'apollo-cache'
import { removeFromPaginated } from 'utils'

import {
  readShareListItemFromCache,
  writeShareListItemToCache,
  updateTrashCache,
} from '../utils'

export interface HandleShareDeletedProps {
  cache: DataProxy
  identifier: string
}

export const handleShareDeleted = (props: HandleShareDeletedProps) => {
  const { cache, identifier } = props

  const share = readShareListItemFromCache({
    cache,
    id: identifier,
  })

  // even if the share is null here,
  // there still can be smaller fragments in the cache
  // let's remove all of them.
  removeFromPaginated(cache, { __typename: 'Share', identifier }, key =>
    key.includes('.shares')
  )

  if (!share) {
    return
  }

  const userIsNotDraftOwner = share.isDraft && !share.userCanUpdateSettings
  if (userIsNotDraftOwner) {
    // Share can only be written to shares trashed cache
    // if current logged in user is the owner of the share
    // because drafts are only shown to owners in trash.
    // This prevents a glitch that shows the share for a bit
    // and then gets overriden by query response.
    return
  }

  if (!share.deletedAt) {
    share.deletedAt = new Date().toISOString()
    writeShareListItemToCache({ cache, share: { ...share } })
  }

  updateTrashCache({
    cache,
    update: workspaceTrash => {
      workspaceTrash.entries.unshift(share)
      workspaceTrash.meta.totalCount++
    },
    variables: { identifier: share.workspace.identifier },
  })
}
